import React from 'react';

import BaseTotal from '../../common/Total';

// Ignoring the prop spreading as this is a HOC that adds "price-summary-box" as the
// BEM block
// eslint-disable-next-line react/jsx-props-no-spreading
const Total = (props) => (<BaseTotal {...props} bemBlock="price-summary-box" />);

export default Total;
